module.exports = __webpack_public_path__ + "static/media/title-page-background.f7dd0dbf.png";